"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Slide_1 = require("@material-ui/core/Slide");
var useTheme_1 = require("@material-ui/core/styles/useTheme");
var useMediaQuery_1 = require("@material-ui/core/useMediaQuery");
var modalStyles_1 = require("./modalStyles");
var ModalPaper_1 = require("./ModalPaper");
var Transition = react_1.forwardRef(function Transition(props, ref) {
    return <Slide_1.default direction="down" ref={ref} {...props} timeout={500}/>;
});
var Modal = react_1.memo(function (_a) {
    var children = _a.children, labelledby = _a.labelledby, hideCloseIcon = _a.hideCloseIcon, onClose = _a.onClose, toggleModal = _a.toggleModal, PaperProps = _a.PaperProps, rest = __rest(_a, ["children", "labelledby", "hideCloseIcon", "onClose", "toggleModal", "PaperProps"]);
    var styles = modalStyles_1.default();
    var isBelowTablet = useMediaQuery_1.default(useTheme_1.default().breakpoints.down('sm'));
    return (<core_1.Dialog aria-labelledby={labelledby} classes={{ paper: styles.container }} onClose={onClose} disableBackdropClick={true} disableEscapeKeyDown={true} PaperComponent={ModalPaper_1.default} PaperProps={__assign(__assign({}, PaperProps), { hideCloseIcon: hideCloseIcon,
        onClose: onClose,
        toggleModal: toggleModal })} {...rest} {...(isBelowTablet ? { fullScreen: true } : {})} TransitionComponent={Transition}>
        {children}
      </core_1.Dialog>);
});
exports.default = Modal;
